<template>
  <div>
    <div
      v-if="createRequestStep==='main'"
      class="list-group list-group-flush"
    >
      <a
        class="list-group-item d-flex justify-content-between align-items-center cursor-enabled"
        @click="createRequestStep='info'"
      >
        <div>
          <img
            src="@/assets/images/icons/request/info.png"
            class="request-icon"
            alt="request-icon"
          >
          {{ $t('newRequestPopupContent.informasiyaSorusu') }}
        </div>
        <div>
          <feather
            type="chevron-right"
            size="20px"
          />
        </div>
      </a>
      <a
        class="list-group-item  d-flex justify-content-between align-items-center  cursor-enabled"
        @click="createRequestStep='price'"
      >
        <div
          :class="{'text-dark cursor-enabled ': canCreate('LOG') || canCreate('RFQ') ,
                   'text-secondary cursor-disabled': !canCreate('LOG') && !canCreate('RFQ') }"
        >
          <img
            v-if="canCreate('LOG') || canCreate('RFQ') "
            src="@/assets/images/icons/request/price.png"
            class="request-icon"
            alt="request-icon"
          >
          <img
            v-else
            src="@/assets/images/icons/lock.png"
            class="request-icon-disabled"
            alt="request-icon-disabled"
          >
          {{ $t('newRequestPopupContent.qiymtSorusu') }}
        </div>
        <div>
          <feather
            type="chevron-right"
            size="20px"
          />
        </div>
      </a>
      <a
        class="list-group-item "
        :class="{'text-dark cursor-enabled ': canCreate('OFR'), 'text-secondary cursor-disabled': !canCreate('OFR') }"
        @click="canCreate('OFR')?$router.push({name: 'newOFFER'}):showProfileRequiredModal('OFR')"
      >
        <img
          v-if="canCreate('OFR')"
          src="@/assets/images/icons/request/offer.png"
          class="request-icon"
          alt="request-icon"
        >
        <img
          v-else
          src="@/assets/images/icons/lock.png"
          class="request-icon-disabled"
          alt="request-icon-disabled"
        >
        {{ $t('newRequestPopupContent.tklifElan') }}
      </a>
      <a
        class="list-group-item "
        :class="{'text-dark cursor-enabled ': canCreate('TRK'), 'text-secondary cursor-disabled': !canCreate('TRK') }"
        @click="canCreate('TRK')?$router.push({name: 'newTRK'}):showProfileRequiredModal('TRK')"
      >
        <img
          v-if="canCreate('TRK')"
          src="@/assets/images/icons/request/truck.png"
          class="request-icon"
          alt="request-icon"
        >
        <img
          v-else
          src="@/assets/images/icons/lock.png"
          class="request-icon-disabled"
          alt="request-icon-disabled"
        >
        {{ $t('newRequestPopupContent.trElan') }}
      </a>
      <a
        class="list-group-item "
        :class="{'text-dark cursor-enabled ': canCreate('TRS'), 'text-secondary cursor-disabled': !canCreate('TRS') }"
        @click="canCreate('TRS')?$router.push({name: 'newTRS'}):showProfileRequiredModal('TRS')"
      >
        <img
          v-if="canCreate('TRS')"
          src="@/assets/images/icons/request/truck-search.png"
          class="request-icon"
          alt="request-icon"
        >
        <img
          v-else
          src="@/assets/images/icons/lock.png"
          class="request-icon-disabled"
          alt="request-icon-disabled"
        >
        {{ $t('newRequestPopupContent.trAxtar') }}
      </a>
      <a
        class="list-group-item "
        :class="{'text-dark cursor-enabled ': canCreate('AUC'), 'text-secondary cursor-disabled': !canCreate('AUC') }"
        @click="canCreate('AUC')?$router.push({name: 'newAUC'}):showProfileRequiredModal('AUC')"
      >
        <img
          v-if="canCreate('AUC')"
          src="@/assets/images/icons/request/auction.png"
          class="request-icon"
          alt="request-icon"
        >
        <img
          v-else
          src="@/assets/images/icons/lock.png"
          class="request-icon-disabled"
          alt="request-icon-disabled"
        >
        {{ $t('newRequestPopupContent.auksion') }}
      </a>
      <a
        class="list-group-item "
        :class="{'text-dark cursor-enabled ': canCreate('REV'), 'text-secondary cursor-disabled': !canCreate('REV') }"
        @click="canCreate('REV')?$router.push({name: 'newREV'}):showProfileRequiredModal('REV')"
      >
        <img
          v-if="canCreate('REV')"
          src="@/assets/images/icons/request/auction-reverse.png"
          class="request-icon"
          alt="request-icon"
        >
        <img
          v-else
          src="@/assets/images/icons/lock.png"
          class="request-icon-disabled"
          alt="request-icon-disabled"
        >
        {{ $t('newRequestPopupContent.ksAuksion') }}
      </a>
      <a
        class="list-group-item "
        :class="{'text-dark cursor-enabled ': canCreate('POL'), 'text-secondary cursor-disabled': !canCreate('POL') }"
        @click="canCreate('POL')?$router.push({name: 'newPOL'}):showProfileRequiredModal('POL')"
      >
        <img
          v-if="canCreate('POL')"
          src="@/assets/images/icons/request/poll.png"
          class="request-icon"
          alt="request-icon"
        >
        <img
          v-else
          src="@/assets/images/icons/lock.png"
          class="request-icon-disabled"
          alt="request-icon-disabled"
        >
        {{ $t('newRequestPopupContent.ssverm') }}
      </a>
    </div>

    <div
      v-if="createRequestStep==='info'"
      class="list-group list-group-flush"
    >
      <a
        class="list-group-item d-flex align-items-center cursor-enabled"
        @click="createRequestStep='main'"
      >
        <feather
          type="chevron-left"
          size="20px"
        />
        {{ $t('newRequestPopupContent.informasiyaSorusu') }}
      </a>
      <a
        class="list-group-item "
        :class="{'text-dark cursor-enabled ': canCreate, 'text-secondary cursor-disabled': !canCreate('LGI') }"
        @click="canCreate('LGI')?$router.push({name: 'newINFO', query: {type: 'LGI'}}):showProfileRequiredModal('LGI')"
      >
        <img
          v-if="canCreate('LGI')"
          src="@/assets/images/icons/request/info.png"
          class="request-icon"
          alt="request-icon"
        >
        <img
          v-else
          src="@/assets/images/icons/lock.png"
          class="request-icon-disabled"
          alt="request-icon-disabled"
        >
        {{ $t('newRequestPopupContent.logistikInformasiyaSorusu') }}
      </a>
      <a
        class="list-group-item "
        :class="{'text-dark cursor-enabled ': canCreate('CSI'), 'text-secondary cursor-disabled': !canCreate('CSI') }"
        @click="canCreate('CSI')?$router.push({name: 'newINFO', query: {type: 'CSI'}}):showProfileRequiredModal('CSI')"
      >
        <img
          v-if="canCreate('CSI')"
          src="@/assets/images/icons/request/info.png"
          class="request-icon"
          alt="request-icon"
        >
        <img
          v-else
          src="@/assets/images/icons/lock.png"
          class="request-icon-disabled"
          alt="request-icon-disabled"
        >
        {{ $t('newRequestPopupContent.gmrkInformasiyaSorusu') }}
      </a>
      <a
        class="list-group-item "
        :class="{'text-dark cursor-enabled ': canCreate('WHI'), 'text-secondary cursor-disabled': !canCreate('WHI') }"
        @click="canCreate('WHI')?$router.push({name: 'newINFO', query: {type: 'WHI'}}):showProfileRequiredModal('WHI')"
      >
        <img
          v-if="canCreate('WHI')"
          src="@/assets/images/icons/request/info.png"
          class="request-icon"
          alt="request-icon"
        >
        <img
          v-else
          src="@/assets/images/icons/lock.png"
          class="request-icon-disabled"
          alt="request-icon-disabled"
        >
        {{ $t('newRequestPopupContent.anbarInformasiyaSorusu') }}
      </a>
      <a
        class="list-group-item "
        :class="{'text-dark cursor-enabled ': canCreate('RFI'), 'text-secondary': !canCreate('RFI') }"
        @click="canCreate('WHI')?$router.push({name: 'newINFO', query: {type: 'RFI'}}):showProfileRequiredModal('RFI')"
      >
        <img
          v-if="canCreate('RFI')"
          src="@/assets/images/icons/request/info.png"
          class="request-icon"
          alt="request-icon"
        >
        <img
          v-else
          src="@/assets/images/icons/lock.png"
          class="request-icon-disabled"
          alt="request-icon-disabled"
        >
        {{ $t('newRequestPopupContent.mumiInformasiyaSorusu') }}
      </a>
    </div>

    <div
      v-if="createRequestStep==='price'"
      class="list-group list-group-flush"
    >
      <a
        class="list-group-item d-flex align-items-center cursor-enabled"
        @click="createRequestStep='main'"
      >
        <feather
          type="chevron-left"
          size="20px"
        />
        {{ $t('newRequestPopupContent.qiymtSorusu') }}
      </a>
      <a
        class="list-group-item "
        :class="{'text-dark cursor-enabled ': canCreate('LOG'), 'text-secondary cursor-disabled': !canCreate('LOG') }"
        @click="canCreate('LOG')?$router.push({name: 'newLogistic'}):showProfileRequiredModal('LOG')"
      >
        <img
          v-if="canCreate('LOG')"
          src="@/assets/images/icons/request/price.png"
          class="request-icon"
          alt="request-icon"
        >
        <img
          v-else
          src="@/assets/images/icons/lock.png"
          class="request-icon-disabled"
          alt="request-icon-disabled"
        >
        {{ $t('newRequestPopupContent.logistikQiymtSorusu') }}
      </a>
      <a
        class="list-group-item "
        :class="{'text-dark cursor-enabled ': canCreate('RFQ'), 'text-secondary cursor-disabled': !canCreate('RFQ') }"
        @click="canCreate('RFQ')?$router.push({name: 'newPQ'}):showProfileRequiredModal('RFQ')"
      >
        <img
          v-if="canCreate('RFQ')"
          src="@/assets/images/icons/request/price.png"
          class="request-icon"
          alt="request-icon"
        >
        <img
          v-else
          src="@/assets/images/icons/lock.png"
          class="request-icon-disabled"
          alt="request-icon-disabled"
        >
        {{ $t('newRequestPopupContent.malVXidmtlrBalQiymtSorusu') }}
      </a>
    </div>
  </div>
</template>
<script>
import {mapState} from "vuex";

export default {
  name: 'NewRequestPopupContent',
  data() {
    return {
      createRequestStep: 'main',

      requestCreate: {
        'LGI': ['PROCUREMENT', 'SUPPLIER'],
        'CSI': ['PROCUREMENT', 'SUPPLIER'],
        'WHI': ['PROCUREMENT', 'SUPPLIER'],
        'LOG': ['PROCUREMENT', 'SUPPLIER'],
        'RFI': ['PROCUREMENT', 'SUPPLIER', 'LOGISTIC'],
        'TRS': ['PROCUREMENT', 'LOGISTIC'],
        'RFQ': ['PROCUREMENT'],
        'PQT': ['PROCUREMENT'],
        'REV': ['PROCUREMENT'],
        'OFR': ['SUPPLIER', 'LOGISTIC'],
        'AUC': ['SUPPLIER'],
        'TRK': ['TRUCK'],
        'POL': ['PROCUREMENT', 'SUPPLIER', 'LOGISTIC'],
      }
    }
  },

  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      profile: state => state.auth.profile,
    }),
  },
  methods: {

    showProfileRequiredModal(requestType) {
      this.$emit('needOtherProfile', this.requestCreate[requestType]);
    },
    canCreate(requestType) {

      if(!this.profile) return false;

      switch (requestType) {
        case 'LGI':
        case 'CSI':
        case 'WHI':
        case 'LOG':
          return ['PROCUREMENT', 'SUPPLIER'].indexOf(this.profile) > -1;
        case 'RFI':
          return ['PROCUREMENT', 'SUPPLIER', 'LOGISTIC'].indexOf(this.profile) > -1;
        case 'TRS':
          return ['PROCUREMENT', 'LOGISTIC'].indexOf(this.profile) > -1;
        case 'RFQ':
        case 'REV':
          return this.profile === "PROCUREMENT";
        case 'OFR':
          return ['SUPPLIER', 'LOGISTIC'].indexOf(this.profile) > -1;
        case 'AUC':
          return ['SUPPLIER'].indexOf(this.profile) > -1;
        case 'TRK':
          return this.profile === "TRUCK";
        case 'POL':
          return this.profile !== "TRUCK";
        default:
          return false;
      }
    },
  }
}
</script>
<style lang="scss" scoped>

.cursor-enabled {
  cursor: pointer;
}

.cursor-disabled {
  cursor: not-allowed;
}

.list-group-item{
   color: #233656;
  font-size: 15px;

  .request-icon{
    height: 30px;
    width: 30px;
  }
  .request-icon-disabled{
    height: 30px;
    width: 30px;
    padding: 3px;
  }

  &:hover{
    background-color: rgba(#2062FB, 0.1);
    border-radius: 6px;
    border-color: transparent;
  }
}
</style>
